import styled from "styled-components";

export const Wrapper = styled.div`
  background: ${({ theme }) => theme.palette.grey[700]};
  border-radius: 0px 16px 16px 16px;
  color: ${({ theme }) => theme.palette.grey[0]};
  margin-top: 24px;
  margin-bottom: 10px;
  overflow-y: scroll;
  padding: 24px;
  position: relative;

  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.palette.grey[900]};
    border-radius: 16px;
    border: ${({ theme }) => `1px solid ${theme.palette.grey[300]}`};
  }
`;

export const MessagesList = styled.div`
  display: flex;
  font-size: 14px;
  margin-top: 12px;
`;
